/*
 * Increase this version number when you want to invalidate all saved carts in the local storage.
 * Mostly used when you change the data structure of the cart.
 */
export const cartVersion = 25;
